import { render, staticRenderFns } from "./unmaintainedDialog.vue?vue&type=template&id=690b1ec0&scoped=true"
import script from "./unmaintainedDialog.vue?vue&type=script&lang=js"
export * from "./unmaintainedDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690b1ec0",
  null
  
)

export default component.exports